import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import Container from '../ui/Container';
import './CTABanner.css';

const CTABanner = () => {
  return (
    <section className="ft-cta">
      <Container>
        <motion.div
          className="ft-cta__panel"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          <h2 className="ft-cta__title">같이 만들 일이 있다면</h2>
          <p className="ft-cta__sub">
            서비스 도입, 협업, 제휴, 채용 — 어떤 이야기든 편하게 보내주세요.
          </p>
          <div className="ft-cta__buttons">
            <Link to="/contact" className="ft-cta__btn ft-cta__btn--solid">
              문의하기
              <ArrowRight size={18} strokeWidth={2.5} />
            </Link>
            <Link to="/products" className="ft-cta__btn ft-cta__btn--soft">
              프로덕트 보기
            </Link>
          </div>
        </motion.div>
      </Container>
    </section>
  );
};

export default CTABanner;
